import {
  Card,
  Description,
  ImgCenterOverlay,
  ImgText,
  ImgWrap,
  InfoBox,
  InfoGrid,
  InfoTitle,
  InfoValue,
  InsideWrap,
  MainText,
  MainTitle,
  SubText,
  Temperature,
  Top,
  TopInsideWrap,
} from "./style.ts";
import {CloudIcon} from "../../../shared/ui/icons/cloudIcon.tsx";
import {SmallCloud} from "../../../shared/ui/icons/smallCloud.tsx";
import {SchedulePart} from "entities/weather/model/types.ts";
import {useState} from "react";
import {ThemeProvider} from "styled-components";

interface WeatherInfoProps {
  forecast: SchedulePart;
  isWidget?: boolean;
  isGrid?: boolean;
}

export const WeatherInfo = (props: WeatherInfoProps) => {
  const { forecast, isWidget = false, isGrid = false } = props;

  const [isDark, _] = useState(
    matchMedia("(prefers-color-scheme: dark)").matches
  );

  return (
    <ThemeProvider theme={{ isWidget }}>
      <Card>
        <MainTitle>
          <SmallCloud />
          Погода на пасеке
        </MainTitle>

        <Top>
          <Temperature>
            {forecast.temp !== null
              ? `${forecast.temp < 0 ? "-" : ""}${Math.abs(forecast.temp)}°`
              : "—"}
          </Temperature>

          <TopInsideWrap>
            {forecast.iconUrl ? (
              <img
                src={forecast.iconUrl}
                alt={forecast.conditionText}
                width={48}
                height={48}
              />
            ) : (
              <CloudIcon />
            )}

            <Description>
              <MainText>{forecast.conditionText}</MainText>
              <SubText>
                Ощущается как{" "}
                {forecast.feelsLike !== null
                  ? `${forecast.feelsLike > 0 ? "+" : ""}${forecast.feelsLike}°`
                  : "—"}
              </SubText>
              {/*<SubText>Вчера было +8°</SubText>*/}
            </Description>
          </TopInsideWrap>
        </Top>

        <InfoGrid $isGrid={isGrid}>
          <InfoBox $isGrid={isGrid}>
            <ImgWrap>
              <img
                src={`/compass${!isDark ? "_light" : ""}.svg`}
                alt="Компас"
              />
              <ImgCenterOverlay>
                <ImgText>{forecast.wind.dirText}</ImgText>
              </ImgCenterOverlay>
            </ImgWrap>

            <InsideWrap>
              <InfoTitle>Ветер</InfoTitle>
              <InfoValue>
                {forecast.wind.speed !== null ? `${forecast.wind.speed}` : "—"}{" "}
                км/ч
              </InfoValue>
            </InsideWrap>
          </InfoBox>

          <InfoBox $isGrid={isGrid}>
            <img src="/drop.svg" alt="Влажность" />
            <InsideWrap>
              <InfoTitle>Влажность</InfoTitle>
              <InfoValue>
                {forecast.humidity !== null ? `${forecast.humidity}%` : "—"}
              </InfoValue>
            </InsideWrap>
          </InfoBox>

          <InfoBox $isGrid={isGrid}>
            <ImgWrap>
              <img
                src={`/pressure${!isDark ? "_light" : ""}.svg`}
                alt="Давление"
              />
              <ImgCenterOverlay>
                <ImgText>{forecast.pressureMm}</ImgText>
              </ImgCenterOverlay>
            </ImgWrap>

            <InsideWrap>
              <InfoTitle>Давление</InfoTitle>
              <InfoValue>
                {forecast.pressureMm !== null ? `${forecast.pressureMm}` : "—"}
              </InfoValue>
            </InsideWrap>
          </InfoBox>

          {/*<InfoBox $isGrid={isGrid}>*/}
          {/*  <ImgWrap>*/}
          {/*    <img src={`/index${!isDark ? "_light" : ""}.svg`} alt="Индекс" />*/}
          {/*    <ImgCenterOverlay>*/}
          {/*      <ImgText>{forecast.uvIndex}</ImgText>*/}
          {/*    </ImgCenterOverlay>*/}
          {/*  </ImgWrap>*/}

          {/*  <InsideWrap>*/}
          {/*    <InfoTitle>УФ-индекс</InfoTitle>*/}
          {/*    <InfoValue>{forecast.uvIndex ?? "—"}</InfoValue>*/}
          {/*  </InsideWrap>*/}
          {/*</InfoBox>*/}
        </InfoGrid>
      </Card>
    </ThemeProvider>
  );
};
